export interface LoginRequest {
  username: string;
  password: string;
  remember?: boolean;
}

export interface LoginResponse {
  token: string;
  username: string;
}

export interface DecodedJwt {
  sub?: string;
  exp?: number; // Unix seconds
  iat?: number;
  [k: string]: unknown;
}

export interface AuthUser {
  id: string;
  username: string;
}

export interface AuthState {
  isAuthenticated: boolean;
  user: AuthUser | null;
  accessToken: string | null;
}

/** Motivos por los que puede fallar un login, cada uno con su propio copy. */
export type LoginErrorCode = 'noConnection' | 'invalidCredentials' | 'tooManyAttempts' | 'generic';

/**
 * Error de login ya traducido. Lleva además el código del motivo para que la
 * vista pueda elegir el aviso correcto: un 429 del backend es un bloqueo
 * temporal por intentos fallidos, no una contraseña incorrecta.
 */
export class LoginError extends Error {
  constructor(
    readonly code: LoginErrorCode,
    message: string,
  ) {
    super(message);
    this.name = 'LoginError';
  }
}
